import { Routes } from '@angular/router';
import { AppLayout } from './app/layout/component/app.layout';
import { Dashboard } from './app/pages/dashboard/dashboard';
import { Documentation } from './app/pages/documentation/documentation';
import { Landing } from './app/pages/landing/landing';
import { Notfound } from './app/pages/notfound/notfound';
import { AuthGuard } from './app/pages/auth/auth-guard';
import { AdminComponent } from './admin/admin.component';
import { adminGuard } from './shared/guards/admin.guard';
import { HomeComponent } from './app/pages/home/home.component';

export const appRoutes: Routes = [
    {
        path: '',
        component: AppLayout,
        canActivate: [AuthGuard],
        children: [
            { path: '', component: HomeComponent },
            {
                path: 'admin',
                component: AdminComponent,
                canActivate: [adminGuard]
              },
            { path: 'modules', loadChildren: () => import('./app/pages/modules/modules.routes')  },
            { path: 'dashboard', component: Dashboard ,canActivate: [adminGuard] },
            { path: 'uikit', loadChildren: () => import('./app/pages/uikit/uikit.routes'), canActivate: [adminGuard] },
            { path: 'documentation', component: Documentation ,canActivate: [adminGuard]},
            { path: 'pages', loadChildren: () => import('./app/pages/pages.routes'), canActivate: [adminGuard] }
        ]
    },
    { path: 'landing', component: Landing  },
    { path: 'notfound', component: Notfound },
    { path: 'auth', loadChildren: () => import('./app/pages/auth/auth.routes') },
    { path: '**', redirectTo: '/notfound' }
];
